function clamp(number, min, max) {
  return Math.min(Math.max(number, min), max);
}

function first(list) {
  return list[0];
}

function last(list) {
  if (list.length <= 1) {
    return list[0];
  }
  return list[list.length - 1];
}

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function carousel() {
  let state = {
    visibleIndices: new Set(),
  };

  let slides = [...document.querySelectorAll(".js-carousel .carousel-item")];
  let $prev = document.querySelector(".js-carousel-prev");
  let $next = document.querySelector(".js-carousel-next");

  let observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          state.visibleIndices.add(entry.target);
        } else {
          state.visibleIndices.delete(entry.target);
        }
      });

      const list = Array.from(state.visibleIndices)
        .map((entry) => {
          return Number(entry.id.slice(5)) || 0;
        })
        .sort();

      if (list.length) {
        $prev.href = `#slide${clamp(first(list) - 1, 0, slides.length)}`;
        $next.href = `#slide${clamp(last(list) + 2, 0, slides.length)}`;
      }
    },
    { threshold: 1 }
  );

  slides.forEach(($slide) => {
    observer.observe($slide);
  });
}

function search() {
  hotkeys("ctrl+k", function (event) {
    event.preventDefault();
    document.querySelector(".js-search-btn").click();
  });
}

function submenu() {
  const navs = document.querySelectorAll(".js-main-nav");

  function getSiblings(el, filter) {
    var siblings = [];
    while ((el = el.nextSibling)) {
      if (!filter || filter(el)) siblings.push(el);
    }
    return siblings;
  }

  for (const nav of navs) {
    const items = [...(nav && nav.children)] || [];

    const separator = items.find(item => {
      return /^\u200b/.test(item.getAttribute('data-value'))
    })

    if (separator) {
      separator.setAttribute("class", "submenu");

      const anchor = separator.querySelector('a')
      if (anchor) {
        anchor.setAttribute("href", "#" + separator.getAttribute('data-value').replace(/^\u200b/, ""));
      }

      const wrapper = document.createElement("ul");
      wrapper.setAttribute("class", "bg-gray-800 p-2 rounded-box space-y-1");

      const children = getSiblings(separator);

      children.forEach(function (child) {
        wrapper.appendChild(child);
      });

      separator.appendChild(wrapper);
      separator.parentNode.appendChild(separator);
    }
  }
}

const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

function preventBodyScroll(element) {
  disableBodyScroll(element, { reserveScrollBarGap: true });
  return () => {
    enableBodyScroll(element);
    return null;
  };
}

function modal() {
  document.querySelectorAll(".js-modal").forEach((element) => {
    const id = element.getAttribute("id");
    const body = document.querySelector("body");

    let preventBodyScrollRef = null;

    function handleInputChange(event) {
      const modalButton = document.querySelector(
        `.modal-button[for=\"${id}\"]`
      );
      if (event.target.checked) {
        modalButton.classList.add("modal-is-open");
        preventBodyScrollRef = preventBodyScroll(body);
      } else {
        modalButton.classList.remove("modal-is-open");
        preventBodyScrollRef = preventBodyScrollRef();
      }
    }

    if (element.nodeName === "INPUT") {
      element.addEventListener("change", handleInputChange);
    }

    if (element.nodeName === "A") {
      if (location.hash === `#${id}`) {
        preventBodyScrollRef = preventBodyScroll(body);
      }
      window.addEventListener("hashchange", () => {
        if (location.hash === `#${id}`) {
          preventBodyScrollRef = preventBodyScroll(body);
        } else if (preventBodyScrollRef) {
          preventBodyScrollRef = preventBodyScrollRef();
        }
      });
    }
  });

  hotkeys("escape", function () {
    document.querySelectorAll(".js-modal").forEach((el) => {
      if (el.checked) {
        el.click();
      }
      if (window.location.hash.slice(1) === el.getAttribute("id")) {
        window.location.hash = "";
      }
    });
  });
}

function header() {
  const headerEl = document.querySelector(".js-header");
  const headroom = new Headroom(headerEl, {
    offset: {
      up: 0,
      down: 64,
    },
  });
  headroom.init();

  // make sure headroom stays visible when mobile-menu is open
  // this prevents the whole created by an unvisible header
  const $mobileMenuStateEl = document.querySelector("input#mobile-menu");
  $mobileMenuStateEl.addEventListener("change", (event) => {
    if (event.target.checked) {
      headroom.freeze();
    } else {
      headroom.unfreeze();
    }
  });
}

function newsletter() {
  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  function showMessage($form, message, type = "error") {
    const $emailField = $form.querySelector(".newsletter");
    const $emailInput = $emailField.querySelector('input[name="email"]');

    if ($emailField && $emailInput) {
      $emailField.setAttribute("data-tip", message);
      if (type === "error") {
        $emailField.classList.add("newsletter-error");
        $emailField.classList.remove("newsletter-success");
      } else if (type === "success") {
        $emailField.classList.add("newsletter-success");
        $emailField.classList.remove("newsletter-error");
      }
      $emailInput.focus();
    }
  }

  function hideMessage($form) {
    const $emailField = $form.querySelector(".newsletter");
    if ($emailField) {
      $emailField.removeAttribute("data-tip");
      $emailField.classList.remove("newsletter-error");
      $emailField.classList.remove("newsletter-success");
    }
  }

  function validate($form) {
    const formData = new FormData($form);
    const email = formData.get("email");

    if (validateEmail(email)) {
      hideMessage($form);
      return true;
    } else {
      showMessage($form, "Invalid Email address", "error");
      return false;
    }
  }

  function submitForm(event) {
    const $form = event.target;
    const $submitButton = $form.querySelector("button.btn");

    if (validate($form)) {
      const formData = new FormData($form);
      const body = JSON.stringify(Object.fromEntries(formData));
      $submitButton.classList.add("loading");

      fetch($form.action, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body,
      })
        .then((response) => response.json())
        .then((json) => {
          $submitButton.classList.remove("loading");
          console.log(json);
          if (json.error) {
            showMessage($form, json.message ?? json.error, "error");
          } else if (json.subscription.state == "active") {
            showMessage(
              $form,
              "Looks like you are already subscribed, thank you!",
              "success"
            );
          } else {
            showMessage(
              $form,
              "Success! Please check your email to confirm your subscription.",
              "success"
            );
          }
        });
    }
  }

  const newsletters = document.querySelectorAll(".js-newsletter");

  if (newsletters.length) {
    newsletters.forEach(($newsletter) => {
      $newsletter.addEventListener("submit", (event) => {
        event.preventDefault();
        submitForm(event);
      });
    });
  }
}

function tabs() {
  document.querySelectorAll(".js-tabs").forEach(($tabs) => {
    const tabsToggleSelector = $tabs.getAttribute("data-tabs-toggle");
    const $tabsToggle = document.querySelector(tabsToggleSelector);
    const tabs = [...$tabs.children];

    $tabs.addEventListener("click", (event) => {
      const $target = event.target;
      const tabTargetSelector = $target.getAttribute("data-tabs-target");
      const $tabTarget = document.querySelector(tabTargetSelector);
      const tabPanels = [...$tabsToggle.children];
      tabs.forEach(($tab) => {
        if ($tab.getAttribute("data-tabs-target") === tabTargetSelector) {
          $tab.classList.add("tab-active");
        } else {
          $tab.classList.remove("tab-active");
        }
      });
      tabPanels.forEach(($tabPanel) => {
        if ($tabPanel === $tabTarget) {
          $tabPanel.classList.remove("hidden");
        } else {
          $tabPanel.classList.add("hidden");
        }
      });
    });
  });
}

$(document).ready(function () {
  // carousel();
  search();
  submenu();
  modal();
  header();
  newsletter();
  tabs();

  hotkeys.filter = function (event) {
    var tagName = (event.target || event.srcElement).tagName;
    hotkeys.setScope(
      /^(INPUT|TEXTAREA|SELECT)$/.test(tagName) ? "input" : "other"
    );
    return true;
  };
});
